module.exports = __webpack_public_path__ + "media/images/global/projects/collaboration-options-e30a94afd2787b873b9b27121d814710.png";